import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';

//Component
import { LOAD_ADDRESS_BOOK } from '../type';
import {
  //List
  loadAddressBookSuccessAction,
  loadAddressBookErrorAction,
} from '../action';

import { addressBookService } from 'services';

function* loadAddressBook() {
  while (1) {
    const action = yield take(LOAD_ADDRESS_BOOK);
    try {
      const addressBook = yield call(
        addressBookService.loadAddressBook,
        action.payload,
      );
      yield put(loadAddressBookSuccessAction(addressBook));
    } catch (err) {
      yield put(loadAddressBookErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

export default function* rootSaga() {
  yield all([loadAddressBook()]);
}
